import type { IChipProps } from '@mofid-securities/uikit';
import { TEtfTransactionState } from '@/services/apis/trade/types';

const DEFAULT_STATUS_VARIANT = 'default';
const STATUS_VARIANT_MAP: Record<TEtfTransactionState, IChipProps['variant']> =
  {
    Doing: 'warning',
    New: 'warning',
    Cancelled: 'default',
    Rejected: 'error',
    Done: 'success',
  };

export const getEtfTransactionStatusVariant = (
  status: TEtfTransactionState
): IChipProps['variant'] => {
  return STATUS_VARIANT_MAP[status] || DEFAULT_STATUS_VARIANT;
};
